<template>
  <div>
    <my-asidebar v-bind:active-tab="'agency'"> </my-asidebar>



    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Acente</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li><a :href="basePath+'/agencies'" class="text-white">Acente</a></li>
                    <li>Detay</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <agency-detail :booking-list="bookingList"></agency-detail>
        <change-password-popup ref="agencyUser"></change-password-popup>
      </div>
    </section>

  </div>
</template>

<script>
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";
import AgencyDetail from "../component/agency/AgencyDetail";
import ChangePasswordPopup from "../component/agency/AgenctChangePasswordPopup";
import Vue from "vue";

export default {
  name: "AgencyDetailPage",
  data:function (){
    return{
      bookingList: [],
    }
  },
  components: {ChangePasswordPopup, AgencyDetail, MyAsidebar, TopBar},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_AGENCY_DETAIL"]) this.$router.push("/");

    if(this.$route.params.id !== undefined && this.$route.params.id !== 'new') {
      this.$store.dispatch("loadAgency", this.$route.params.id);

      this.$store.dispatch("loadAgencyCommissionRateList", this.$route.params.id);

      Vue.set(this,"bookingList", []);
      this.$store.dispatch("loadAgencyBookingList",this.$route.params.id).then(response => {
        Vue.set(this,"bookingList", response);
      })
    }else{
      this.$nextTick(()=>{
        this.$store.commit("setAgency",{id:null})
      })
    }

    this.$store.dispatch("loadCruise").then(()=>{
      this.$store.dispatch("loadRoomList")
    });
    this.$store.dispatch("loadMarketList");
  }
}
</script>

<style scoped>

</style>